// extracted by mini-css-extract-plugin
module.exports = {"container":"TabSetComponent_container__1E6C8"};